import React, { useEffect, useState, useRef } from "react";
import CloseForm from "../Master/CloseForm";
import axios from "axios";
import "../../css_files/Admin/DetailsRoleTable.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axiosInstance from "../../api";

function DetailsRoleTable({ setshowdetailsroletable, role, isAdmin }) {
  const [detailroles, setdetailroles] = useState([]);
  const [triggerupdate, settriggerupdate] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    setloading(true);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Roles/GetRoleByRoleName?roleName=${role}`
      )
      .then((res) => {
        setdetailroles(res.data.permissions);
        settriggerupdate(
          Array.from({ length: res.data.permissions.length }, (_) => false)
        );
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  }, [refresh, role]);

  const [actions, setactions] = useState({
    read: false,
    write: false,
    update: false,
    delete: false,
  });

  function handlechange(e) {
    setactions({ ...actions, [e.target.value]: e.target.checked });
  }

  function handleUpdate(id, role, head, subhead) {
    const url = `${process.env.REACT_APP_API_URL}/api/Permissions`;
    axios
      .put(url, {
        id: id,
        Role: role,
        Head: head,
        SubHead: subhead,
        IsRead: actions.read,
        IsWrite: actions.write,
        IsUpdate: actions.update,
        IsDelete: actions.delete,
      })
      .then((res) => {
        console.log(res);
        toast.success(res.data, {
          position: "bottom-center",
        });
        setrefresh(!refresh);
        settriggerupdate((prev) => prev.map((_) => false));
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to Update permissions", {
          position: "bottom-center",
        });
      });
  }

  return (
    <section className="details-role-table">
      <section className="details-role-table-section">
        <h1>Details Role Table</h1>
        <section className="table">
          <section>
            <div>
              <aside
                style={{
                  gridTemplateColumns: `repeat(${isAdmin ? "6" : "4"}, 1fr)`,
                }}
              >
                <blockquote style={{ minWidth: "15rem" }}>Role Name</blockquote>
                <blockquote style={{ minWidth: "15rem" }}>Head</blockquote>
                <blockquote style={{ minWidth: "15rem" }}>Sub Head</blockquote>
                <blockquote style={{ minWidth: "15rem" }}>
                  Permissions
                </blockquote>
                {isAdmin && (
                  <blockquote
                    style={{ gridColumn: "span 2", minWidth: "10rem" }}
                    align="center"
                  >
                    Actions
                  </blockquote>
                )}
              </aside>
            </div>
            <div>
              {loading ? (
                <aside
                  style={{
                    gridTemplateColumns: `repeat(${isAdmin ? "6" : "4"}, 1fr)`,
                  }}
                >
                  <blockquote
                    style={{ gridColumn: `span ${isAdmin ? "6" : "4"}` }}
                  >
                    <center>
                      <i
                        className="fa-solid fa-rotate-right fa-spin"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </center>
                  </blockquote>
                </aside>
              ) : detailroles.length > 0 ? (
                detailroles.map((detailrole, index) => (
                  <aside
                    key={index}
                    style={{
                      gridTemplateColumns: `repeat(${
                        isAdmin ? "6" : "4"
                      }, 1fr)`,
                    }}
                  >
                    <blockquote style={{ minWidth: "15rem" }}>
                      {detailrole.role}
                    </blockquote>

                    <blockquote style={{ minWidth: "15rem" }}>
                      {detailrole.head}
                    </blockquote>
                    <blockquote style={{ minWidth: "15rem" }}>
                      {detailrole.subHead}
                    </blockquote>
                    <blockquote style={{ minWidth: "15rem" }}>
                      {triggerupdate[index] ? (
                        <>
                          <mark>
                            Read:
                            <input
                              type="checkbox"
                              value="read"
                              checked={actions.read}
                              onChange={handlechange}
                            />
                          </mark>
                          <mark>
                            Write:
                            <input
                              type="checkbox"
                              value="write"
                              checked={actions.write}
                              onChange={handlechange}
                            />
                          </mark>
                          <mark>
                            Update:
                            <input
                              type="checkbox"
                              value="update"
                              checked={actions.update}
                              onChange={handlechange}
                            />
                          </mark>
                          <mark>
                            Delete:
                            <input
                              type="checkbox"
                              value="delete"
                              checked={actions.delete}
                              onChange={handlechange}
                            />
                          </mark>
                        </>
                      ) : (
                        <p>{`${detailrole.isRead ? "Read ," : ""} ${
                          detailrole.isWrite ? "Write ," : ""
                        } ${detailrole.isUpdate ? "Update ," : ""} ${
                          detailrole.isDelete ? "Delete" : ""
                        }`}</p>
                      )}
                    </blockquote>
                    {isAdmin && (
                      <>
                        <blockquote
                          style={{ textAlign: "center", minWidth: "5rem" }}
                        >
                          {triggerupdate[index] ? (
                            <i
                              className="fa-solid fa-xmark"
                              title="Close"
                              onClick={() =>
                                settriggerupdate((prev) => {
                                  const arr = [...prev];
                                  arr[index] = false;
                                  return arr;
                                })
                              }
                              style={{ fontSize: "1.5rem" }}
                            ></i>
                          ) : (
                            <i
                              className="fa-solid fa-pen-to-square"
                              title="Edit"
                              onClick={() => {
                                settriggerupdate((prev) => {
                                  return prev.map((_, i) => i === index);
                                });
                                setactions({
                                  ...actions,
                                  read: detailrole.isRead,
                                  write: detailrole.isWrite,
                                  update: detailrole.isUpdate,
                                  delete: detailrole.isDelete,
                                });
                              }}
                            ></i>
                          )}
                        </blockquote>

                        <blockquote
                          style={{ textAlign: "center", minWidth: "5rem" }}
                        >
                          {triggerupdate[index] ? (
                            <i
                              class="fa-solid fa-floppy-disk"
                              style={{ color: "green" }}
                              onClick={() =>
                                handleUpdate(
                                  detailrole.id,
                                  detailrole.role,
                                  detailrole.head,
                                  detailrole.subHead
                                )
                              }
                            ></i>
                          ) : (
                            <i
                              className="fa-solid fa-trash"
                              title="Delete"
                              onClick={() => {
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "You won't be able to revert this!",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes, delete it!",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    axios
                                      .delete(
                                        `${process.env.REACT_APP_API_URL}/api/Permissions?id=${detailrole.id}`
                                      )
                                      .then((res) => {
                                        console.log(res);
                                        toast.success(res.data, {
                                          position: "bottom-center",
                                        });
                                        setrefresh(!refresh);
                                      })
                                      .catch((err) => {
                                        console.log(err);
                                        toast.error("Failed to delete", {
                                          position: "bottom-center",
                                        });
                                      });
                                  }
                                });
                              }}
                            ></i>
                          )}
                        </blockquote>
                      </>
                    )}
                  </aside>
                ))
              ) : (
                <aside
                  style={{
                    gridTemplateColumns: `repeat(${isAdmin ? "6" : "4"}, 1fr)`,
                  }}
                >
                  <blockquote
                    style={{ gridColumn: `span ${isAdmin ? "6" : "4"}` }}
                  >
                    <center>No Records Found</center>
                  </blockquote>
                </aside>
              )}
            </div>
          </section>
        </section>
        <CloseForm close={setshowdetailsroletable} />
      </section>
    </section>
  );
}

export default DetailsRoleTable;
